import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { DrawerSchema } from "schemas";

export function useComments({ refreshKey }) {
  const { fetchData, loading, data: comments } = GeneralFetch();
  const drawer = useRecoilValue(DrawerSchema);

  useEffect(() => {
    if (!drawer?.open || !drawer?.data?.objectId) return;

    void fetchData(
      { object: drawer.object, object_id: drawer.data.objectId },
      "getComents",
      "post",
      "comments"
    ).catch(() => undefined);
  }, [drawer?.data?.objectId, drawer?.object, drawer?.open, refreshKey]);

  return { comments, loading };
}
